<template>
    <div class="head">
      <nav class="navbar navbar-default container">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
            <span class="sr-only"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <div class="navbar-brand logo fadeInLeft animated" data-wow-delay=".5s">
            <img src="../images/logo.svg">
          </div>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div ref="navWill" class="collapse navbar-collapse nav-wil"  id="bs-example-navbar-collapse-1" :class="{ active: isActive }">
          <ul class="nav navbar-nav fadeInDown animated">
            <li><router-link to="/"> <span>{{$t('global.Home')}}</span></router-link></li>
            <li><router-link to="news"> <span>{{$t('global.News')}}</span></router-link></li>
            <li><router-link to="tracking"> <span>{{$t('global.Tracking')}}</span></router-link></li>
            <li><router-link to="product-list"> <span>{{$t('global.Products')}}</span></router-link></li>
            <li><router-link to="help"> <span>{{$t('global.Help')}}</span></router-link></li>
            <li><router-link to="about"> <span>{{$t('global.About')}}</span></router-link></li>
            <!---->
               <li id="site">
              <a> <span><img src="../images/china.png" alt="">{{$t('global.cnSite')}}</span></a>
              <a class="login-link" :href="jpSiteUrl"> <span><img src="../images/japan.png" alt="">{{$t('global.jpSite')}}</span></a>
              <a class="login-link" :href="uaeSiteUrl" style="top:65px"> <span><img src="../images/uae.png" alt="">United Arab Emirates</span></a>
            </li>
            <li class="lang"><a><span @click="toggleLang">{{ languageText }}</span></a></li>
            <!---->
            <!-- <li><a target="_blank" href="https://www.edisebay.com"> <span>{{$t('global.Login')}}</span></a></li> -->
            <li id="goLogin">
              <a> <span>{{$t('global.Login')}}</span></a>
              <a class="login-link" target="_blank" href="https://edis.ebay.com/login"> <span>{{$t('global.SPKLogin')}}</span></a>
            <a class="login-link" target="_blank" href="https://mc-seller.orangeconnex.com"> <span>{{$t('global.MCLogin')}}</span></a>
            </li>

          </ul>
        </div>
        <!-- /.navbar-collapse -->
      </nav>
    </div>
</template>

<script>
  const browserLan = navigator.language === 'en' ? 'en-US' : 'zh-CN'
  import Cookies from 'js-cookie';
  export default {
        name: "Head",
        data(){
            return {
              isActive: false,
              uaeSiteUrl:'https://www.orangeconnex.ae',
              jpSiteUrl:process.env.NODE_ENV !== 'production' ? 'https://jp-test.orangeconnex.com/?from=cn' : 'https://www.orangeconnex.jp/?from=cn',
              language: Cookies.get('language') === undefined ? browserLan : Cookies.get('language'),
              defaultLanguage: 'zh-CN'
            }
        },
        computed: {
          languageText () {
            if (this.language === 'zh-CN'){
              return 'English';
            } else {
              return '中文';
            }
          }
        },
        methods:{
          toggleLang(){
            if (this.language === 'zh-CN'){
              // this.languageText  = 'English';
              this.$i18n.locale = 'en-US';
              this.language = 'en-US'
            } else {
              // this.languageText  = '中文';
              this.$i18n.locale = 'zh-CN';
              this.language = 'zh-CN'
            }
            this.$store.dispatch('getNewsList',{ language: this.$i18n.locale });
            this.$store.dispatch('loadContinents',{ language: this.$i18n.locale });
            if (this.$route.query && this.$route.query.language) {
              //设置语言
              this.$i18n.locale = this.$route.query.language === 'en' ? 'zh-CN' : 'en-US'
              //切换了值但是url没有变化,是因为是同一个vue页面组件
              this.$route.query.language = this.$route.query.language === 'en' ? 'cn' : 'en'
              //设置最新的语言
              Cookies.set('language',this.$i18n.locale);
            } else {
              Cookies.set('language',this.$i18n.locale);
              // location.reload();
            }
          }
        },
        created(){
          document.addEventListener('click', (e) => {
            let sp = this.$refs.navWill;
            if (event.target){
              this.isActive = !this.isActive
            }
          })
        },
    }
</script>
<style lang="less" scoped>
.login-link{
 display: none;
}
#goLogin:hover{
  a:first-child{
      color: #ee7532;
    &::after,&::before {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      transform: translateY(0px);
    }
  }
  .login-link{
   display: block;
    position: absolute;
    width: 210px;
    left: 50%;
    margin-left: -100px !important;
    text-align: center;
    &::after,&::before{
      display: none;
    }
    &:last-child{
      top: 68px;
    }
  }
}
#site{
  img{
    display: inline-block;
    width: 16px;
    height: 16px ;
    margin-right: 8px;
    margin-top: -1px;
  };
}
#site:hover{

  a:first-child{
      color: #ee7532;
    &::after,&::before {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      transform: translateY(0px);
    }
  }
  .login-link{
   display: block;
    position: absolute;
    width: 210px;
    left: 50%;
    margin-left: -100px !important;
    text-align: center;
    &::after,&::before{
      display: none;
    }
    // &:last-child{
    //   top: 68px;
    // }
  }
}
</style>




// WEBPACK FOOTER //
// Head.vue?e686fff2